<template>
    <div class="btn-group">
        <button class="btn btn-sm" :class="{'btn-danger': !isBound, 'btn-secondary': isBound}" @click="toggle">
            <i class="fas" :class="{'fa-unlink': isBound, 'fa-link': !isBound}"></i>
        </button>
    </div>
</template>

<script>
  export default {
    props: [
      'row'
    ],

    computed: {
      /**
       * @return {boolean}
       */
      isBound() {
        return _.isNull(this.row.bound);
      },
    },

    methods: {
      /**
       * @event toggle
       */
      toggle() {
        this.$emit('toggle', {model: this.row.model});
      },
    }
  }
</script>
